module.exports = __webpack_public_path__ + "img/Hong Kong.7bb4c68d.svg";